export class UserTokenModel {
  constructor(private _accessToken: string, private _refreshToken: string) {}

  get token() {
    return this._accessToken;
  }

  get refreshToken() {
    return this._refreshToken;
  }
}
